class Infobox {
	constructor() {
		this.initialized = false;
		this.popupId = 128;
		this.popupElement = null;
		this.storageKey = `tht-popup-${this.popupId}`;
		this.timestampAttribute = 'data-tht-last-modified';
		this.openClass = 'tht-popup-open';
		this.currentTimestamp = null;
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.popupElement = document.querySelector(
			`.brxe-popup-${this.popupId}`
		);

		if (!this.popupElement) {
			return;
		}

		this.currentTimestamp =
			this.popupElement.getAttribute(this.timestampAttribute) ||
			Date.now().toString();

		this.addCloseButtonHandler();
		this.showIfNeeded();

		this.initialized = true;
	}

	showIfNeeded() {
		const storedTimestamp = localStorage.getItem(this.storageKey);

		if (!storedTimestamp || this.hasChanged(storedTimestamp)) {
			this.show();
		}
	}

	show() {
		this.popupElement.classList.add(this.openClass);
	}

	hide() {
		localStorage.setItem(this.storageKey, this.currentTimestamp);
		this.popupElement.classList.remove(this.openClass);
	}

	addCloseButtonHandler() {
		const closeBtn = this.popupElement.querySelector('.tht-popup-close');
		closeBtn?.addEventListener('click', () => this.hide());
	}

	hasChanged(storedTimestamp) {
		const storedNum = Number(storedTimestamp);
		const currentNum = Number(this.currentTimestamp);

		if (Number.isNaN(storedNum) || Number.isNaN(currentNum)) {
			return true;
		}

		return storedNum < currentNum;
	}
}

export const infobox = new Infobox();
